var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfocorner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52V40C52 46.6274 46.6274 52 40 52H0V0Z",
    fill: "#4D5BEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18C30.4062 18 34 21.5938 34 26C34 30.4375 30.4062 34 26 34C21.5625 34 18 30.4375 18 26C18 21.5938 21.5625 18 26 18ZM26 22C25.4375 22 25 22.4688 25 23C25 23.5625 25.4375 24 26 24C26.5312 24 27 23.5625 27 23C27 22.4688 26.5312 22 26 22ZM27.25 30C27.6562 30 28 29.6875 28 29.25C28 28.8438 27.6562 28.5 27.25 28.5H26.75V25.75C26.75 25.3438 26.4062 25 26 25H25C24.5625 25 24.25 25.3438 24.25 25.75C24.25 26.1875 24.5625 26.5 25 26.5H25.25V28.5H24.75C24.3125 28.5 24 28.8438 24 29.25C24 29.6875 24.3125 30 24.75 30H27.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfocorner);
export default __webpack_public_path__ + "static/media/infocorner.e9860602f4fcbb96b4d9fa95767974b1.svg";
export { ForwardRef as ReactComponent };